import React, { useState } from 'react';
import MoreVertIcon from '@mui/icons-material/MoreVert';

import { useTranslation } from '../../context/TranslationContext';

import DarkModeToggle from './DarkModeToggle';
import SoundControl from './SoundControl';
import LanguageSelector from './LanguageSelector';
import { HeaderMoreButton, OverflowMenu, HeaderOverflowControls } from './styles';

/** Compact-header "⋮" button that collapses the control group into a dropdown. */
const HeaderOverflowMenu = () => {
  const { translate } = useTranslation();
  const [anchorEl, setAnchorEl] = useState(null);
  const isOpen = Boolean(anchorEl);

  return (
    <>
      <HeaderMoreButton
        aria-controls={isOpen ? 'header-overflow-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={isOpen ? 'true' : undefined}
        aria-label={translate('header.moreOptions')}
        color="inherit"
        size="small"
        open={isOpen}
        onClick={(event) => setAnchorEl(event.currentTarget)}
      >
        <MoreVertIcon />
      </HeaderMoreButton>
      <OverflowMenu
        id="header-overflow-menu"
        anchorEl={anchorEl}
        open={isOpen}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <HeaderOverflowControls>
          <DarkModeToggle variant="row" />
          <SoundControl variant="row" />
          <LanguageSelector variant="row" />
        </HeaderOverflowControls>
      </OverflowMenu>
    </>
  );
};

export default HeaderOverflowMenu;
